import { withPlaceholder } from '@sitecore-jss/sitecore-jss-react';
import { PlaceholderProps } from '@sitecore-jss/sitecore-jss-react/types/components/PlaceholderCommon';
import { Carousel, CarouselDefaultContainer, Container, mediaQuery } from 'db-npm-e4sc-rd-ui';
import React from 'react';
import styled from 'styled-components';
import { Section } from '../../shared/components';
import { useIsEditor } from '../../shared/hooks';

const StyledContainer = styled(Container)`
  ${mediaQuery.lgDown} {
    padding-left: 0 !important;
    padding-right: 0 !important;
    max-width: 100% !important;
  }
`;

const ExperienceEditorCarousel = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  .scEmptyPlaceholder {
    flex: auto;
  }
`;

export type NewsListHorizontalProps = PlaceholderProps & {
  newsItemsHorizontal: any;
};

const NewsListHorizontal: React.FC<NewsListHorizontalProps> = ({ newsItemsHorizontal }) => {
  const hasNewsItems = newsItemsHorizontal && newsItemsHorizontal.length > 0;
  const isEditor = useIsEditor();
  const showNewsItems = hasNewsItems || isEditor;

  return (
    <Section componentName="NewsListHorizontal" margin="small">
      <StyledContainer>
        {showNewsItems &&
          (isEditor ? (
            <CarouselDefaultContainer>
              <ExperienceEditorCarousel>{newsItemsHorizontal}</ExperienceEditorCarousel>
            </CarouselDefaultContainer>
          ) : (
            <CarouselDefaultContainer>
              <Carousel>{newsItemsHorizontal}</Carousel>
            </CarouselDefaultContainer>
          ))}
      </StyledContainer>
    </Section>
  );
};

export default withPlaceholder('newsItemsHorizontal')(NewsListHorizontal as any);
